// extracted by mini-css-extract-plugin
export default {"filter":"ProductFilter_filter__CCfwe","category":"ProductFilter_category__tdhub","brand":"ProductFilter_brand__bMlhI","active":"ProductFilter_active__21TE8"};